import React, { useEffect, useState, useCallback } from 'react';
import { FaChevronUp } from 'react-icons/fa';

const BackTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  const handleScroll = useCallback(() => {
    setIsVisible(window.scrollY >= 800);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  const handleBackTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <div
      className={`back_top ${isVisible ? 'popped' : ''}`}
      title="Back to top"
      onClick={handleBackTop}
      role="button"
      tabIndex="0"
      aria-label="Scroll back to top"
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          handleBackTop();
        }
      }}
    >
      <FaChevronUp />
    </div>
  );
};

export default BackTop;